export default "__VITE_ASSET__UULj9Akm__"